import {httpService} from "@/modules/common/services"


const getCampaigns = async () => {
  try {
    let result = await httpService.get('campaigns',{automatic: true})
    return result
  } catch (e) {
    return e.response.data
  }
}

const getCampaign = async (campaignUid) => {
  try {
    let result = await httpService.get(`campaigns/${campaignUid}`)
    return result
  } catch (e) {
    return e.response.data
  }
}

const saveCampaign = async (campaign) => {
  try {
    let result = await httpService.put(`campaigns/${campaign.uid}`,campaign)
    return result
  } catch (e) {
    return e.response.data
  }
}

const sendCampaign = async (campaign) => {
  try {
    let result = await httpService.post(`campaigns/${campaign.uid}/send_campaign`,campaign)
    return {status : 'OK', data: result}
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}

const sendMailValidation = async (staffUid) => {
  try {
    let result = await httpService.get(`staffs/send_validation_email`,{id:staffUid})
    return {status : 'OK', data: result}
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}

const checkTatangoKeyword = async (keyword) => {
  try {
    let result = await httpService.get(`settings/campaign_keyword/check_keyword`,{keyword:keyword})
    return {status : 'OK', data: result}
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}

const getCampaignSuggestions = async (type) => {
  try {
    let result = await httpService.get('campaigns/suggested_campaigns_by_category',{type:type})
    return {status : 'OK', data: result.data}
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}

const cloneSuggestion = async (campaignUid) => {
  try {
    let result = await httpService.post(`campaigns/${campaignUid}/clone_suggestion`)
    return {status : 'OK', data: result}
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}

const setTatangoKeyword = async (keyword) => {
  try {
    let result = await httpService.post(`settings/campaign_keyword/set_keyword`,{keyword:keyword})
    return {status : 'OK', data: result}
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}

const getTatangoKeyword = async () => {
  try {
    let result = await httpService.get(`settings/campaign_keyword`)
    return {status : 'OK', data: result}
  } catch (e) {
    throw {status : 'ERROR', data: e}
  }
}


export default {
  getCampaigns,
  getCampaign,
  saveCampaign,
  sendCampaign,
  sendMailValidation,
  checkTatangoKeyword,
  setTatangoKeyword,
  getTatangoKeyword,
  getCampaignSuggestions,
  cloneSuggestion
};
